<template>
  <div>
    <div class="receipt-header">
      <div class="logo">
        <img src="/assets/images/logo.png" alt="company_logo" />
      </div>
      <div class="company-info">
        <h4 class="header-title">
          <b>{{ companyName }}</b>
        </h4>
        <h6 class="header-subtitle">{{ companyAddress }}</h6>
        <h6 class="header-subtitle">Telp. {{ phone }}</h6>
      </div>
      <div v-if="supplierOrigin" class="supplier-origin">
        <span>{{ supplierOrigin }}</span>
      </div>
    </div>
    <div class="border-header"></div>
  </div>
</template>

<script>
export default {
  name: 'ReceiptHeader',
  props: {
    type: {
      type: String,
      required: true,
      validator: value => ['outlet', 'warehouse'].includes(value)
    },
    data: {
      type: Object,
      required: true
    },
    supplierOrigin: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    companyName() {
      return (this.data && this.data.name) || 'MPOS SYSTEM'
    },
    companyAddress() {
      return (this.data && this.data.address) || 'Jl. Laksana No 68 ABC'
    },
    phone() {
      return (this.data && this.data.phone) || '(061) 6643780'
    }
  }
}
</script>

<style scoped lang="scss">
.receipt-header {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  padding: 0.5rem;
  position: relative;

  .logo {
    width: 60px;
    margin-right: 1rem;
    img {
      width: 100%;
      height: auto;
    }
  }

  .company-info {
    flex: 1;
    .header-title {
      font-size: 1.2rem;
      margin: 0;
      line-height: 1.2;
    }
    .header-subtitle {
      font-size: 0.9rem;
      margin: 0;
      line-height: 1.2;
    }
  }

  .supplier-origin {
    margin-left: auto;
    align-self: flex-start;
    font-size: 2rem;
    font-weight: bold;
    text-align: right;
    min-width: 180px;
    word-break: break-word;
  }
}

.border-header {
  border-top: 2px solid #000;
  width: 100%;
  margin: 12px 0 0 0;
  justify-content: center;
}

@media print {
  .receipt-header {
    page-break-inside: avoid;
  }
}
</style>
